import styled, { css, keyframes } from 'styled-components';
import { AnimateType } from './BannerModel';

const slideInLeft = keyframes`
   from {
    transform: translate3d(-300px, 0, 0);
    visibility: visible;
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0) scale(1);
    opacity:1;
  }
}`;

const slideInRight = keyframes`
  from {
    transform: translate3d(300px, 0, 0);
    visibility: visible;
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0) scale(1);
    opacity:1;
  }
}`;

const prevFrame = keyframes`
  from {
    visibility: visible;
    opacity: 1;
  }

  to {
    visibility: visible;
    opacity: 1;
  }
}`;

export const Wrap = styled.div`
  width: 100%;
`;
export const Arrows = styled.div<{ Show?: boolean }>`
  position: absolute;
  top: 50%;
  width: 100%;
  opacity: ${({ Show }) => (Show ? 1 : 0)};
  transition: opacity 0.2s;
`;
export const Arrow = styled.div<{ Left?: boolean; Right?: boolean }>`
  width: 35px;
  height: 40px;
  background: #ffffff;
  position: absolute;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 1;
  svg path {
    fill: rgba(9, 21, 38);
    fill-opacity: 0.6;
  }
  &:hover {
    svg path {
      fill-opacity: 0.85;
    }
  }
  ${({ Left }) =>
    Left &&
    css`
      justify-content: flex-start;
      left: 0;
      border-radius: 0 100px 100px 0;
    `};
  ${({ Right }) =>
    Right &&
    css`
      justify-content: flex-end;
      right: 0;
      border-radius: 100px 0px 0px 100px;
    `};
`;
export const Title = styled.div`
  font-size: 16px;
  line-height: 22px;
`;

export const Subtitle = styled.div`
  margin-top: 4px;
  font-size: 16px;
  line-height: 22px;
  font-weight: normal;
`;

export const ButtonOld = styled.div`
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 19px;
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
`;

export const Buttons = styled.div`
  display: flex;
`;

export const Button = styled.a<{ bgColor?: string; color?: string; type?: string }>`
  display: block;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;

  ${(props) =>
    props.type === 'contained' &&
    css`
      border-radius: 8px;
      padding: 10px 16px;
      background: ${props.bgColor || '#ffffff'};
    `};

  ${(props) =>
    props.type === 'outlined' &&
    css`
      border-radius: 8px;
      padding: 9px 15px;
      border: 1px solid ${props.bgColor || '#ffffff'};
    `};

  ${(props) => props.type === 'text' && css``};

  color: ${(props) => props.color || 'rgba(9, 21, 38, 0.85)'};

  &:visited,
  &:focus,
  &:active,
  &:hover {
    outline: none;
    color: ${(props) => props.color || 'rgba(9, 21, 38, 0.85)'};
  }
`;

export const Control = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const Inner = styled.a<{ animate: AnimateType; img: string; isCurrent: boolean; href?: string }>`
  padding: 20px 40px;
  position: absolute;
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.1;
  background-repeat: no-repeat;
  border-radius: 16px;
  cursor: ${(props) => (props.href ? 'pointer' : 'default')};

  ${({ animate }) => {
    if (animate === 'slideInLeft') {
      return css`
        animation: ${slideInLeft} 0.5s;
      `;
    }
    if (animate === 'slideInRight') {
      return css`
        animation: ${slideInRight} 0.5s;
      `;
    }
    if (animate === 'prevFrame') {
      return css`
        animation: ${prevFrame} 0.5s;
      `;
    }
    return null;
  }};
  ${({ img }) =>
    img
      ? css`
          background-size: contain;
          background-image: url(${`${img}`});
        `
      : css`
          background: #bfccdd;
        `};

  ${({ isCurrent }) =>
    isCurrent &&
    css`
      transition: visibility 0.1;
      visibility: visible;
      z-index: 1;
      opacity: 1;
    `};
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
`;
export const RightSide = styled.div``;
export const Picture = styled.div``;
export const Space = styled.div`
  flex: 1 0 auto;
`;

export const Banner = styled.div`
  height: 200px;
  border-radius: 16px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  z-index: 1;
  &:hover {
    ${ButtonOld} {
      background: rgba(255, 255, 255, 1);
    }
  }
`;

export const Point = styled.div<{ isCurrent: boolean }>`
  cursor: pointer;
  width: 8px;
  height: 8px;
  margin: 0 3px;
  background: ${({ isCurrent }) => (isCurrent ? 'rgba(9, 21, 38, 0.85)' : 'rgba(9, 21, 38, 0.15)')};
  border-radius: 50%;
  &:hover {
    background: ${({ isCurrent }) => (isCurrent ? 'rgba(9, 21, 38, 0.85)' : ' rgba(9, 21, 38, 0.6)')};
  }
`;
